import React from 'react';

export default function NotificationPanel() {
  return (
    <div>
      <h2>Notification Panel</h2>
      <p>Placeholder for notification panel</p>
    </div>
  );
}
